<template>
  <div>
      <div><h2 id="gene-name" class="gene-name"><b><i>{{ datalist.accession }} </i></b><span class="gene-production">{{ datalist.protein }}</span></h2></div>
      <div class="baimoc-card">
           <!-- 条目1 Summary-->
          <span class="baimoc-card-header baimoc-card-tag header-primary">Protein Summary</span>
          <div style="padding: 10px 20px 0px 10px"> </div>
             <!---->
             <div>
                 <table class="table table-condensed table-hover">
                 <tbody>
                   <tr>
                      <td class = "right"><strong>Name

                      </strong></td>
                      <td>{{datalist.protein}}</td>
                  </tr>
                  <tr>
                      <td class=""><strong>Gene(s)
                      </strong></td>
                      <td >{{datalist.gene}}</td>
                  </tr>
                  <tr>
                      <td class=""><strong>Organism
                      </strong></td>
                      <td > <a :href="[ 'https://www.ncbi.nlm.nih.gov/Taxonomy/Browser/wwwtax.cgi?id=' + datalist.tax_id,]"
      style="text-decoration: none">{{ datalist.organism }}</a></td>
                  </tr>
                  <tr>
                      <td class=""><strong>Metal(s)
                      </strong></td>
                      <td >
                        <el-button v-for="item in val(datalist.symbol)" :key="item.id" type="primary" plain>{{item}}</el-button>
                      </td>
                  </tr>
                   <tr>
                      <td class=""><strong>Mass
                      </strong></td>
                      <td >{{datalist.mass}}</td>
                  </tr>
                  <tr>
                      <td class=""><strong>Length
                      </strong></td>
                      <td >{{datalist.length}}</td>
                  </tr>
                  <tr>
                      <td class=""><strong>Sequence
                      </strong></td>
                      <td id="seq" ><small>{{datalist.sequence}}</small></td>
                  </tr>
                 </tbody>
             </table>
              <!--序列-->
             </div>
             <!---->
         <!-- 条目2 Sequence Site-->
          <span class="baimoc-card-header baimoc-card-tag header-primary" >Sequence Site</span>
          <div id="pfv">
          </div>
          <div style="margin-top:30px;">
            <br>
<div class="resultbox-bottom">
  <el-table
:data="valstr(datalist)"
stripe
border
style="width: 100%"
max-height="250">
<el-table-column
  type="index"
  
  :resizable="false"
  label="#"
  width="170px"
></el-table-column>
<el-table-column
prop="0"
label="Site">
</el-table-column>
<el-table-column
prop="1"
label="Metal">
<template slot-scope="scope">
    <a
      :href="[
        'https://evidenceontology.org/browse/#' + scope.row[1],
      ]"
      style="text-decoration: none"
      ><el-button type="primary" plain>{{scope.row[1]}}</el-button></a
    >
  </template>
 
</el-table-column>
<el-table-column
prop="2"
label="Evidence">
<template slot-scope="scope">
    <a
      :href="[
        'https://evidenceontology.org/browse/#' + scope.row[2],
      ]"
      style="text-decoration: none"
      >{{ scope.row[2] }}</a
    >
  </template>
</el-table-column>
<el-table-column
prop="3"
label="Description">
</el-table-column>
<el-table-column
prop="4"
label="Residues">
</el-table-column>
</el-table>
   </div>
</div>
 <!-- 条目3 Strcture Site-->
 <span class="baimoc-card-header baimoc-card-tag header-primary">Strcture Site</span>
  <el-table
:data="pdblist"
stripe
border
style="width: 100%"
max-height="250">
<el-table-column
  type="index"
  :resizable="false"
  label="#"
  width="170px"
></el-table-column>
<el-table-column
prop="instance"
label="Instance">
<template slot-scope="scope">
    <a
      :href="[
        'http://www1.rcsb.org/sequence/' +
          scope.row.instance +
          '#' +
          scope.row.chain,
      ]"
      style="text-decoration: none"
      >{{ scope.row.instance }}</a
    >
  </template>
</el-table-column>
<el-table-column label="PDB Code" prop="code">
  <template slot-scope="scope">
    <a
      :href="[
        'https://www.ebi.ac.uk/pdbe/entry/pdb/' + scope.row.code,
      ]"
      style="text-decoration: none"
      >{{ scope.row.code }}</a
    >
  </template>
</el-table-column>
<el-table-column label="Cofactor(s)" prop="symbol">
     <template slot-scope="scope">
      <el-button v-for="item in symbol(scope.row.symbol)" :key="item.id" type="primary" plain>{{item}}</el-button>
    </template></el-table-column>
     <el-table-column label="Chain" prop="chain"></el-table-column>
     <el-table-column label="Pfam" prop="pfam">
  <template slot-scope="scope">
    <a
      :href="['http://pfam.xfam.org/family/' + val2(scope.row.pfam)]"
      style="text-decoration: none"
      >{{ scope.row.pfam }}</a
    >
  </template>
</el-table-column>
<el-table-column label="CATH" prop="cath">
  <template slot-scope="scope">
    <a
      :href="[
        'http://www.cathdb.info/version/v4_3_0/superfamily/' +
          val2(scope.row.cath),
      ]"
      style="text-decoration: none"
      >{{ scope.row.cath }}</a
    >
  </template>
</el-table-column>
 <el-table-column label="SCOP" prop="scop">
  <template slot-scope="scope">
    <a
      :href="[
        'https://scop.mrc-lmb.cam.ac.uk/scop/search.cgi?sccs=' +
          val2(scope.row.scop),
      ]"
      style="text-decoration: none"
      >{{ scope.row.scop }}</a
    >
  </template>
</el-table-column>
<el-table-column label="View" prop="instance">
    <template slot-scope="scope">
      <a :href="['@/../#/mol/?id='+scope.row.instance]" target="_blank" style="text-decoration:none;">
      <el-button type="primary" icon="el-icon-thumb" plain round>Click</el-button></a>
    </template>
  </el-table-column>
    
</el-table>
  <div class="resultbox-bottom">
 
</div>
  <!-- 条目4 Strcture Site-->
  <span class="baimoc-card-header baimoc-card-tag header-primary">Gene Ontology</span>
  <div class="resultbox-bottom">
 <h5 style="color:#696969;font-weight: bold;font-size: 1em;margin-bottom:0px;">Biological processs:</h5>
  <hr>
  <el-table
:data="val(datalist.pro)"
stripe
border
style="width: 100%"
max-height="250">
<el-table-column
prop="id"
label="id">
<template slot-scope="scope">
    <a
      :href="['https://www.ebi.ac.uk/QuickGO/term/'+scope.row.id]"
      style="text-decoration:none;"
    >{{scope.row.id}}</a>
  </template>
</el-table-column>
<el-table-column
prop="term"
label="term">
</el-table-column>
<el-table-column
prop="project"
label="project">
</el-table-column>
<el-table-column
prop="evidence"
label="evidence">
<template slot-scope="scope">
    <a
      :href="[
        'https://evidenceontology.org/browse/#' + scope.row.evidence,
      ]"
      style="text-decoration: none"
      >{{ scope.row.evidence }}</a
    >
  </template>
</el-table-column>
</el-table>

<hr>
<h5 style="color:#696969;font-weight: bold;font-size: 1em;margin-bottom:0px;">Molecular function:</h5>

  <hr>

<el-table
:data="val(datalist.mol)"
stripe
border
style="width: 100%"
max-height="250">
<el-table-column
prop="id"
label="id">
<template slot-scope="scope">
    <a
      :href="['https://www.ebi.ac.uk/QuickGO/term/'+scope.row.id]"
      style="text-decoration:none;"
    >{{scope.row.id}}</a>
  </template>
</el-table-column>
<el-table-column
prop="term"
label="term">
</el-table-column>
<el-table-column
prop="project"
label="project">
</el-table-column>
<el-table-column
prop="evidence"
label="evidence">
<template slot-scope="scope">
    <a
      :href="[
        'https://evidenceontology.org/browse/#' + scope.row.evidence,
      ]"
      style="text-decoration: none"
      >{{ scope.row.evidence }}</a
    >
  </template>
</el-table-column>
</el-table>
<hr>
          </div>
          <!-- 条目5 EC Number-->
   <span class="baimoc-card-header baimoc-card-tag header-primary">Interactions</span>
          <div id="stringEmbedded"></div>
    <!-- 条目6 Strcture Site-->
     <!-- 条目5 EC Number-->
  
    <!-- 条目6 Strcture Site-->
   <!-- 条目5 EC Number-->
   <span class="baimoc-card-header baimoc-card-tag header-primary">Catalytic Activity</span>
          <div class="resultbox-bottom"><ul style="font-size: 18px;color: #606266;">
    <li> EC Number :<span style="color: #2d995b">
      <a
      :href="['http://www.ebi.ac.uk/intenz/query?cmd=SearchEC&ec='+datalist.ec]"
      style="text-decoration:none;"
    >{{datalist.ec}}</a>
    </span> </li>
                  <li>Describe : <span style="color: #2d995b">{{datalist.text}}</span></li>
                  </ul></div>
    <!-- 条目6 Strcture Site-->
     <!-- 条目7 Strcture Site-->
          </div> 
      </div>
</template>


<style scoped  src="../assets/css/plugins/bootstrap.min.css"></style>
<style lang="less" scoped>
/*baimoc card - css*/
.baimoc-card {
  box-shadow: 0 1px 4px 0 rgba(0,0,0,0.13);
  background: white;
  border: 1px solid transparent;
  margin: 10px;
  margin-left:30px;
}
.baimoc-card-header {
  display: inline-block;
  color: #fff!important;
  padding: 5px;
  font-weight: 600;
  border: 0 solid transparent;
  border-radius: 0 5px 5px 0;
  font-size: 1.1rem;

  /*相对位置*/
  top: 10px;
  left: -21px;
  margin-right: -10px;
  padding-left: 25px;
  padding-right: 15px;
  margin-bottom: 20px;
}

.baimoc-card-tag {
  position: relative;

}
#stringEmbedded{
width:976px;
margin: auto;
}
.baimoc-card-header:after {
  position: absolute;
  content: '';
  top: 100%;
  left: 0;
  background-color: transparent!important;
  border-style: solid;
  border-width: 0 20px 20px 0;
  border-color: transparent;
  border-right-color: inherit;
  width: 0;
  height: 0;
}

.header-primary {
  background-color: #4b7bec;
  border-color: #3867d6!important;
}



/*baimoc badge*/



.baimoc-subtitle{
  margin-top: 20px;
  padding-left: 0em;
  padding-left: 10px;
  font-size: 18px;
  border-left: 4px solid #ff7e79;
  line-height: 1.4;
  margin-bottom: 0em;
}

.baimoc-card-hr{
  margin-top: 5px;
  margin-bottom: 5px;
}
#pfv{
width:100%;
margin: auto;
}
.gene-name {
  color: #333;
  margin: 0px;
  margin: 10px 10px 10px 30px;
  margin-top: 15px;
  font-style: italic;
  font-weight: 300;
  font-size: 2em;
  padding: 0px 0px 0px 0px;
  padding-left: 0;
  border-bottom: 3px solid #000;
}

.gene-production {
  font-size: 0.4em;
}
.resultbox-bottom {
  margin-bottom: 40px;
  padding-top:20px;
padding-left: 13px;
border-top: 0px;
border-bottom-left-radius: 6px;
border-bottom-right-radius: 6px;
line-height: 1.5em;
text-align: justify;
}

/deep/.el-table--border td{
border-top:0.1px solid rgb(219, 223, 219);
}
#seq{
height: 10px;
overflow: hidden;
word-break:break-all;
margin-bottom: 20px;
small{
 background-color: #e2e2e2;
}
}
.right{
width: 230px;
}
</style>

<script>
import("3dmol/build/3Dmol-min.js");
import * as RcsbFv from "@rcsb/rcsb-saguaro";
import {getSTRING}  from "../assets/string";
export default {
name: 'Content',
components: {
},
data() {
return {
 total: null,
flag:false,
datalist: [],
page_size: 10,
page: 1,
termslist:[],
sitelist:[],
pdblist:[],
ec:[,],
msg: 'category'
};
},

created() {
this.getData();
this.pdbData();
},
methods: {
async getData() {
const res = await this.$http.get("contents", {
  params: { accession: this.$route.query["accession"] },
});
if (res.status !== 200) {
  return this.$message.error("获取数据列表失败");
}
this.datalist = res.data.results[0];
 getSTRING('https://string-db.org', {
                    'species':this.datalist.tax_id,
                    'identifiers':[this.datalist.accession,],
                    'network_flavor':'confidence', 
                    'caller_identity': 'www.awesome_app.org'
        });
//           //
var ls_site = eval(this.datalist.site)
var ls_ion = eval(this.datalist.metal)
var color = {
"V":"#888888",
"cluster":"#FF0099",
"Fe":"#CC6633",
"Zn":"#006699",
"W":"#000000",
"Mo":"#CCCC33",
"Cu":"#CC6600",
"Mn":"#CC00FF",
"Ni":"#99CCCC",
"Mg":"#4B0082",
"Hg":"#FFFFFF",
"K":"#00CC99",
"X":"#EEEEEE",
"Co":"#000099",
"Ca":"#330066",
"Na":"#00FF66",
"Cd":"#333300",
};
var param = []; 
 for(var i = 0; i < ls_site.length; i++){   
  param.push({begin:eval(ls_site[i]),color:"#4B0082",title:ls_ion[i]});  
}  
 const sequence = this.datalist.sequence;
const boardConfigData = {
length: sequence.length,
trackWidth: 1400,
//trackWidth: window.innerWidth * 0.83,
includeAxis: true
};

const rowConfigData = [
{
trackId: "sequenceTrack",
trackHeight: 40,
trackColor: "#F9F9F9",
displayType: "sequence",
nonEmptyDisplay: true,
rowTitle: "SEQUENCE",
trackData: [
{
  begin: 1,
  value: sequence
}
]
},
{
trackId: "pinTrack",
trackHeight: 55,
trackColor: "#F9F9F9",
displayType: "pin",
displayColor: "#65F253",
rowTitle: "METAL",

trackData: param,
}
];

const elementId = "pfv";
const pfv = new RcsbFv.RcsbFv({
      boardConfigData,
      rowConfigData,
      elementId
  });

        
},
async pdbData() {
const res = await this.$http.get("pdblistcontent" , {
  params: {
    accession:this.$route.query["accession"],
    page: this.page,
    page_size: this.page_size,
  },
});
if (res.status !== 200) {
  return this.$message.error("获取数据列表失败");
}
this.pdblist = res.data.results;
console.log(this.pdblist)
this.total = res.data.count;
console.log(this.total)
}, //

collapse(){
if(this.flag==false){
document.getElementById("seq").style.height="auto"
this.flag=!this.flag
}else{
document.getElementById("seq").style.height="40px"
this.flag=!this.flag
}
},
//

//
drawLine(){
  // 基于准备好的dom，初始化echarts实例
  let myChart = this.$echarts.init(document.getElementById('myChart'))
  // 绘制图表
  myChart.setOption({
    tooltip: {
  trigger: 'item',
  formatter: '{a} <br/>{b}: {c} ({d}%)'
},
legend: {
  orient: 'vertical',
  left: 6,
  data: ['Viruses', 'Archaea', 'Bacteria', 'Fungi', 'Others','Plant', 'Aniaml']
},
series: [
  {
      name: 'Number',
      type: 'pie',
      selectedMode: 'single',
      radius: [0, '30%'],

      label: {
          position: 'inner'
      },
      labelLine: {
          show: false
      },
      data: [
          {value: 944, name: 'Viruses', },
          {value: 127, name: 'Archaea'},
          {value: 1920, name: 'Bacteria'},
          {value: 4248, name: 'Eukaryota',selected: true},
      ]
  },
  {
      name: 'Number',
      type: 'pie',
      radius: ['40%', '55%'],
      label: {
          formatter: '{a|{a}}{abg|}\n{hr|}\n  {b|{b}：}{c}  {per|{d}%}  ',
          backgroundColor: '#eee',
          borderColor: '#aaa',
          borderWidth: 1,
          borderRadius: 4,
          // shadowBlur:3,
          // shadowOffsetX: 2,
          // shadowOffsetY: 2,
          // shadowColor: '#999',
          // padding: [0, 7],
          rich: {
              a: {
                  color: '#999',
                  lineHeight: 22,
                  align: 'center'
              },
              // abg: {
              //     backgroundColor: '#333',
              //     width: '100%',
              //     align: 'right',
              //     height: 22,
              //     borderRadius: [4, 4, 0, 0]
              // },
              hr: {
                  borderColor: '#aaa',
                  width: '100%',
                  borderWidth: 0.5,
                  height: 0
              },
              b: {
                  fontSize: 16,
                  lineHeight: 33
              },
              per: {
                  color: '#eee',
                  backgroundColor: '#334455',
                  padding: [2, 4],
                  borderRadius: 2
              }
          }
      },
      data: [
          {value: 944, name: 'Viruses'},
          {value: 127, name: 'Archaea'},
          {value: 1920, name: 'Bacteria'},
          {value: 401, name: 'Fungi'},
          {value: 158, name: 'Others'},
          {value: 1028, name: 'Plant'},
          {value: 2661, name: 'Aniaml'},
      ]
  }
]    
      
})
//option结束

},
//处理后端字符串
symbol(str){
var res = eval(str);
return res;
},
val(str){
var res = eval(str);
return res;
},
val2(str) {
if (typeof str == "undefined" || str == null || str == "") {
  var arr = "";
} else {
  var arr = str.split("|")[0];
}
return arr;
},
valstr(str){
var a = eval(str.site);

var b = eval(str.metal);
var c = eval(str.des);
var seq = str.sequence;
var eco = eval(str.eco);
var arr = [];
if(a){
for(var i=0;i<a.length;i++){
arr[i]=[a[i],b[i],eco[i],c[i],seq[a[i]-1],c[i]]
}
}
return arr;
},
//
},

};

</script>
